<script>
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { icons } from "@/helpers/data-fontawesome";
import Middleware from "@/helpers/middlewares";

/**
 * up sell Component
 */
export default {
  page: {
    title: "Maintenance Request",
  },
  components: {},
  data() {
    return {
      maintenanceRequest: {
        name: "",
        icon: "fas fa-concierge-bell",
        is_active: true,
      },
      editId: null,
      submitted: false,
      isBtnLoading: false,
      isImageUploading: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: "",
      icons: icons,
      typeBaseIcons: [],
    };
  },
  computed: {
    ...authComputed,
  },
  validations: {
    maintenanceRequest: {
      name: {
        required,
      },
      icon: {
        required,
      },
    },
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to set icons
    setIcons() {
      let brand = [];
      let solid = [];
      let regular = [];
      for (let entry of icons) {
        if (entry.attributes.membership.free.length && entry.id != undefined) {
          for (let value of entry.attributes.membership.free) {
            switch (value) {
              case "brands":
                brand.push({ icon: `fab fa-${entry.id}`, show: entry.id });
                break;
              case "solid":
                solid.push({ icon: `fas fa-${entry.id}`, show: entry.id });
                break;
              default:
                regular.push({ icon: `far fa-${entry.id}`, show: entry.id });
            }
          }
        }
      }
      this.typeBaseIcons = [
        {
          iconName: "brands",
          icons: brand,
        },
        { iconName: " solid", icons: solid },
        { iconName: "regular", icons: regular },
      ];
    },
    // Method is used to set single icon
    setIcon(icon) {
      this.maintenanceRequest.icon = icon.icon;
      this.$bvModal.hide("icon-list-modal");
    },

    setValue() {
      if (this.currentProps.isEdit) {
        UserService.getMaintenceRequestDetails(this.currentProps.updateValueId)
          .then((response) => {
            this.editId = response.id;
            this.maintenanceRequest.name = response.name;
            this.maintenanceRequest.icon = response.icon;
            this.maintenanceRequest.is_active = response.is_active;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
          name: this.maintenanceRequest.name,
          icon: this.maintenanceRequest.icon,
          is_active: true,
        };
        if (!this.currentProps.isEdit) {
          UserService.createMaintenceRequest(data)
            .then((response) => {
              if (this.isSaveAndAddNew) {
                this.$emit("saveAndAddNew", response);
              } else {
                this.$emit("submitted", response);
              }
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification(
                "Request type added successfully !!",
                "success"
              );
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          UserService.updateMaintenceRequest(
            this.currentProps.updateValueId,
            data
          )
            .then((response) => {
              this.$emit("submitted", response, this.currentProps.isEdit);
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification("Successfully updated !!", "success");
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
  },
};
</script>

<template>
  <div>
    <b-form ref="staff-form">
      <div class="row align-items-end">
        <div class="col-md-12">
          <b-card-title>
            <h4>
              {{ this.currentProps.isEdit ? "Update" : "Add" }} Maintenance
              Request Details
            </h4>
            <h4 v-if="createError">
              <template v-if="typeof errorMessage == 'object'">
                <span v-for="error in errorMessage" :key="error">
                  <span class="badge card-badge badge-soft-danger">
                    <b>{{ error }}</b>
                  </span>
                  <br />
                </span>
              </template>
              <template v-else>
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ errorMessage }}</b>
                </span>
              </template>
            </h4>
          </b-card-title>
          <hr />
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label-for="name-input">
            <span slot="label">Name <span class="text-danger">*</span></span>
            <b-form-input
              id="name-input"
              type="text"
              placeholder="name"
              v-model="maintenanceRequest.name"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.maintenanceRequest.name.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.maintenanceRequest.name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.maintenanceRequest.name.required"
                >Name is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group class="mb-3" label-for="icon-input">
            <span slot="label"
              >Icon <span class="text-danger">*</span>
              <b-button
                variant="outline-primary"
                class="btn-sm ms-2"
                v-b-modal.icon-list-modal
                @click="setIcons"
                >Select Icon</b-button
              ></span
            >
            <b-form-input
              disabled
              id="icon-input"
              type="text"
              placeholder="fas fa-pen"
              v-model="maintenanceRequest.icon"
              autocomplete="off"
              class=""
              :class="{
                'is-invalid': submitted && $v.maintenanceRequest.icon.$error,
              }"
            ></b-form-input>
            <div
              v-if="submitted && $v.maintenanceRequest.icon.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.maintenanceRequest.icon.required"
                >Icon is required.</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <div class="btn btn-dark mb-3" v-if="maintenanceRequest.icon">
            <i class="fs-6" :class="maintenanceRequest.icon"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel</b-button
          >
          <b-button
            v-if="this.currentProps.isEdit === false"
            class="float-end ms-2"
            variant="outline-primary"
            type="button"
            :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
            @click="saveAndAddNew"
          >
            <i
              v-if="isSaveAndAddNew === true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Save & Add</b-button
          >
          <b-button
            class="float-end"
            variant="outline-primary"
            @click="handleSubmit"
            :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew !== true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>

    <!-- Modal is for add new folio -->
    <b-modal id="icon-list-modal" size="xl" centered hide-footer hide-header>
      <div class="row">
        <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 pb-0">
          <b-tab v-for="(icon, index) in typeBaseIcons" :key="index">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ icon.iconName }}</span>
            </template>
            <div class="row icon-demo-content" id="solid">
              <div
                class="col-xl-3 col-lg-4 col-sm-6"
                v-for="(icon, iconIndex) in icon.icons"
                :key="iconIndex"
                @click="setIcon(icon)"
              >
                <i :class="icon.icon"></i>{{ icon.show }}
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>
